import {makeAutoObservable} from "mobx";

class PatientPageStore {
//Компонент информаци о пользователе
    patientInfo = {}
    discount = false
//Компонет с информацией об резульатах
    patientResults = []
//Модалка результата
    resultModal = {
        show: false,
        resultId: '',
        image: 'false'
    }
    saleModal = {
        show: true
    }
    //Модалка смены пароля
    passwordChangeModal = {show: false}
    //Модалка смены информации о пользователе
    patientInfoChangeModal = {show: false}
	// отозвать доступ
	resetPasswordModal = {show: false}

    constructor() {
        makeAutoObservable(this)
    }

    setDiscount =  (value)=>{
        this.discount = value
    }
    toggleSaleModal = ()=>{
        this.saleModal.show = !this.saleModal.show
    }
    setPatientInfo(data) {
        this.patientInfo = data
    }

    setPatientResults(data) {
        this.patientResults = data
    }

    showResultModal(resultId) {
        this.resultModal = {
            show: true,
            resultId: resultId,
            image: ''
        }
    }

    closeResultModal() {
        this.resultModal = {
            show: false,
            resultId: null
        }
    }

    setResultModelImage(image) {
        this.resultModal = {
            ...this.resultModal, image: image
        }
    }

    showPasswordChangeModal() {
        this.passwordChangeModal = {
            show: true
        }
    }

    closePasswordChangeModal() {
        this.passwordChangeModal = {
            show: false
        }
    }

    showResetPasswordModal() {
        this.resetPasswordModal = {
            show: true
        }
    }

	
	closeResetPasswordModal() {
		this.resetPasswordModal = {
            show: false
        }
	}

    showPatientInfoChangeModal() {
        this.patientInfoChangeModal = {
            show: true
        }
    }

    closePatientInfoChangeModal() {
        this.patientInfoChangeModal = {
            show: false
        }
    }


}


export default new PatientPageStore()